// extracted by mini-css-extract-plugin
export default {"container":"Profile_container__4DR1n","logoutButton":"Profile_logoutButton__8r2hc"};